
        var result = require("!!../../../node_modules/style-loader/index.js!../../../node_modules/css-loader/index.js!./formulario.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/admin/tipificacion/formulario.component.css
// module id = 465
// module chunks = 0